export * from './slider';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@angular/material/slider/index.js
// module id = ../../../material/slider/index.js
// module chunks = 3